import React from 'react';
import PropTypes from 'prop-types';

const Logo = ({ small, xsmall }) => {
  return xsmall ? (
    <svg
      version="1.1"
      focusable="false"
      role="presentation"
      x="0px"
      y="0px"
      width="22px"
      height="22px"
      viewBox="0 0 300.4 278.2"
    >
      <path
        d="M296.3,239.3c-21.3,3.7-33.2-5.6-42.9-31.1C250,199.3,179.4,5.8,179.4,5.8c-41.6,1.6-56.8,7.1-72.2,48.2
C83.7,117,50.3,205.8,50.3,205.8c-11.5,30.3-21.8,40.8-40.2,44.9l-5.6,1.2v22.2h101.5l0-22.8l-7.9-1.5c-17.3-3.3-21.3-7.8-21.3-16.3
c0-6.3,3.5-15.8,7.8-27.7l3.3-9.2h57.8c18.3,0,23.4-13.2,24.7-18.3l9.7,26.8c10,27.4,25.8,68.9,74,68.9
C287,274.1,298.8,252.3,296.3,239.3z M102.3,157.3L132.6,74l30.2,83.3H102.3z"
      />
    </svg>
  ) : small ? (
    <svg
      version="1.1"
      focusable="false"
      role="presentation"
      x="0px"
      y="0px"
      width="32.39px"
      height="30px"
      viewBox="0 0 300.4 278.2"
    >
      <path
        d="M296.3,239.3c-21.3,3.7-33.2-5.6-42.9-31.1C250,199.3,179.4,5.8,179.4,5.8c-41.6,1.6-56.8,7.1-72.2,48.2
C83.7,117,50.3,205.8,50.3,205.8c-11.5,30.3-21.8,40.8-40.2,44.9l-5.6,1.2v22.2h101.5l0-22.8l-7.9-1.5c-17.3-3.3-21.3-7.8-21.3-16.3
c0-6.3,3.5-15.8,7.8-27.7l3.3-9.2h57.8c18.3,0,23.4-13.2,24.7-18.3l9.7,26.8c10,27.4,25.8,68.9,74,68.9
C287,274.1,298.8,252.3,296.3,239.3z M102.3,157.3L132.6,74l30.2,83.3H102.3z"
      />
    </svg>
  ) : (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="110.2px"
      height="40px"
      viewBox="0 0 1175.5 426.7"
    >
      <path
        d="M1092.1,293.8c0-13.8-3.4-27.5-15.6-31.9c-7-2.5-15.8-0.5-20.4,6.8c-4.3,6.8-1,16.8,6.5,22.4
c1.3,12-5.2,19.8-14.1,19.8c-0.2,0-0.3,0-0.5,0l0-0.1c-0.7,0-1.5,0-2.2-0.2c-6.7-1.1-11-6.7-11.5-14.3l0-108.9h37.9
c10.3,0,18.6-8.3,18.6-18.6v-19.5h-56.4l0-69.3c-32.4,1.2-44.3,5.5-56.2,37.5l-5.9,14.4c-4.2,10.3-14.2,17-25.3,17h-22.3
c-3.5,0-7-0.9-9.9-2.7c-21-12.9-43.5-14.4-60.9-14.4c-49.6,0-87.8,26-87.8,62.2c0,36.6,19.3,53.1,65.5,66.3
c32.7,9.4,56.1,19.9,56.1,37.8c0,13.9-11.3,22.5-32.1,22.5c-14.6,0-35.9-7.4-44.2-30.1c-2-5.6-7.4-9.3-13.4-9.3h-33.1v14.6
c0,8.5-5.5,14.6-14.9,14.6c-7.3,0-13.2-6.5-13.2-14.8l-0.1-3.1v-93.6c0-32.2-16.2-67-88.4-67c-38,0-78.8,15.6-83.1,47.7
c-2.7,19.9,8.5,33.4,31.2,31.9c13-0.9,34.7-7.9,21.2-46.5c38.5-13,54.7,8.9,54.7,31v21.4c-71.1,12.5-96.6,16.6-124.7,58.3
c-15.6,23.1-35.6,29.9-61.8,29.7c-33.5-0.2-59-26.4-59-69.6c0-51.9,24.3-74.2,56.7-71.3c0,0-13.8,47,26.1,47c20,0,31.4-12,31.4-32.1
c0-28.7-28.9-47.4-68.7-47.4c-59.7,0-110,46.5-110,110.6c0,23.1,8.4,40.5,17,57.5c-3,4.7-8.2,9.2-15.3,9.2
c-13.8,0-21.6-18.9-27.5-34.5C329.7,257.7,265,80,265,80c-41.6,1.6-56.9,7.1-72.2,48.2c-23.5,63.1-56.9,151.8-56.9,151.8
c-11.6,30.3-21.8,40.8-40.2,44.9l-5.6,1.2v22.2h101.6l0-22.8l-7.9-1.5c-17.3-3.3-21.3-7.8-21.3-16.3c0-6.3,3.5-15.8,7.8-27.7
l3.3-9.2h57.9c18.3,0,23.4-13.2,24.7-18.3l12.6,35.2c14.9,40.4,33.4,60.5,73.8,60.5c27.3,0,43.5-11.8,51.8-27.8
c19.7,18.4,47.5,27.6,79,27.6c33.6,0,56.6-11.3,76.4-32.7c6.4,17.8,24.5,32.9,60,32.9c32.9,0,53.1-11.1,64.5-31.1
c8.1,19.3,26.9,30.7,51.7,30.7c24.6,0,39.5-9.1,49.1-26.4c16.2,17.3,47.4,26.8,77.8,26.8c53,0,91.2-18.8,91.2-61.8
c0-33.7-18.2-53.2-67.4-69.5c-37.8-12.5-53.8-16.7-54.1-34.1c-0.2-13.2,16.7-23.3,33.5-23.3c14.3,0,32.1,2.9,46.1,20.5
c3.6,4.5,9,7.1,14.8,7.1h12.7l37.8,0v95.8c0,41.6,25.6,65.2,65.4,65.2v0c0,0,0,0,0,0c0,0,0,0,0,0l0,0
C1072.4,348.4,1092.1,322.3,1092.1,293.8z M187.7,231.6l30.3-83.3l30.2,83.3H187.7z M671.6,289.8C651,314,609.1,312,609.1,285
c0-27.1,38.9-34.1,62.5-40.6V289.8z"
      />
    </svg>
  );
};

Logo.propTypes = {
  xsmall: PropTypes.bool,
  small: PropTypes.bool,
  color: PropTypes.string,
};

export default Logo;
